import styled from 'styled-components';

const PricesContainer = styled.div`
	position: relative;

	${props => props.theme.breakpoints.up('xs')} {
		padding: 0% 8% 15% 8%;
	}
	${props => props.theme.breakpoints.up('sm')} {
		min-height: 2600px;
		padding: 0%;
	}

	${props => props.theme.breakpoints.up('md')} {
		min-height: 1400px;
	}

	.prices__data {
		text-align: center;
		${props => props.theme.breakpoints.up('md')} {
			width: 100%;
			position: absolute;
			top: -190px;
		}
		h2 {
			padding-bottom: 15px;
			font-weight: 300;
			${props => props.theme.breakpoints.up('xs')} {
				font-size: 33px;
			}
			${props => props.theme.breakpoints.up('sm')} {
				font-size: 40px;
			}
		}
	}

	.prices__list {
		${props => props.theme.breakpoints.up('md')} {
			position: relative;
			top: -120px;
			width: 100%;
			padding: 0px 12%;
		}
		background-color: transparent;
	}
`;

export default PricesContainer;
